import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme/palette';
import { SvgIconProps } from './SvgIcon.types';

export const ArrowUp = memo(({ className, color = colors.primary.main, fontSize = 12 }: SvgIconProps) => {
  return (
    <SvgIcon
      className={className}
      style={{ fontSize }}
      width="13"
      height="8"
      viewBox="0 0 13 8"
      fill="none"
      fontSize="inherit"
    >
      <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.0019 6.0025C12.0027 5.8709 11.9773 5.74043 11.9273 5.6186C11.8773 5.49676 11.8036 5.38594 11.7105 5.2925L6.68556 0.292502C6.49727 0.106251 6.24255 0.00170926 5.97705 0.00170925C5.71155 0.00170923 5.45683 0.106251 5.26854 0.292502L0.243609 5.2925C0.0789656 5.4838 -0.00706724 5.72988 0.00270236 5.98155C0.012472 6.23323 0.117324 6.47197 0.296306 6.65006C0.475289 6.82816 0.715218 6.93249 0.968149 6.94221C1.22108 6.95193 1.46838 6.86633 1.66064 6.7025L5.97202 2.4125L10.2834 6.7025C10.4234 6.84292 10.602 6.93889 10.7968 6.97828C10.9916 7.01766 11.1937 6.99869 11.3777 6.92377C11.5616 6.84884 11.7191 6.72133 11.8302 6.55734C11.9414 6.39336 12.0011 6.20027 12.0019 6.0025Z"
          fill={color}
        />
      </svg>
    </SvgIcon>
  );
});
